import React, { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  IonItem,
  IonLabel,
  IonItemSliding,
  IonItemOptions,
  IonItemOption,
  IonNote,
} from '@ionic/react';
import { OrderSelectors } from 'redux/OrderRedux';
import { formatCurrency } from 'utils/currency';

function CartItem({ venueId, cartItem, onEdit, onDelete }) {
  const ref = useRef(null);
  const menuItem = useSelector(
    OrderSelectors.selectMenuItem(venueId, cartItem.item.id)
  );

  const handleOpen = () => {
    if (ref.current) {
      ref.current.open();
    }
  };
  const clickWrapper = (func) => () => {
    if (ref.current) {
      ref.current.close();
    }
    func();
  };

  const modifierTotal = useMemo(
    () =>
      cartItem.modifiers.reduce(
        (prev, modifier) => prev + (modifier.item.price * cartItem.quantity),
        0
      ),
    [cartItem.modifiers]
  );

  return (
    <IonItemSliding ref={ref}>
      <IonItem button onClick={handleOpen}>
        <IonLabel>
          {cartItem.quantity}&nbsp;
          {menuItem && menuItem.name}
        </IonLabel>
        <IonNote slot="end" className="menuitem-price">
          {menuItem
            ? formatCurrency(menuItem.price * cartItem.quantity + modifierTotal)
            : '-'}
        </IonNote>
      </IonItem>
      <IonItemOptions>
        <IonItemOption color="success" onClick={clickWrapper(onEdit)}>
          Edit
        </IonItemOption>
        <IonItemOption color="danger" onClick={clickWrapper(onDelete)}>
          Delete
        </IonItemOption>
      </IonItemOptions>
    </IonItemSliding>
  );
}

CartItem.propTypes = {
  venueId: PropTypes.string,
  cartItem: PropTypes.object,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

export default CartItem;
